import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {Router} from '@angular/router';
import {BlockService} from '../../service/BlockService';
import {UserService} from '../../service/UserService';
import {EmitterService} from '../../service/EmitterService';
import { MatSort, MatTableDataSource, MatPaginator } from '@angular/material';
import { OpenFicheService } from '../../service/open-fiche.service';
import { OpenFicheRequest } from '../../model/OpenFicheRequest';
import * as moment from 'moment';
import { DATE_D_M_Y_SLASH_FORMAT } from '../../model/commons/DateConstants';

@Component({
  selector: 'app-unlock-requests-suivi',
  templateUrl: './unlock-requests-suivi.component.html',
  styleUrls: ['./unlock-requests-suivi.component.css']
})
export class UnlockRequestsSuiviComponent implements OnInit, AfterViewInit {
  displayedColumns = [ 'demandeur', 'agent', 'dateFiche', 'dateDemande', 'motif', 'status'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource();
  loading= false;
  @ViewChild(MatSort) sort: MatSort;
  public Display = {
    row: ['Réalisé validé'],
    breaks: false,
    header: true,
    paginator: false,
    buttons: {
      valider: false,
      claim: false
    },
    styles: {
      margin: {top: -10, right: 40, bottom: 20, left: 100},
      height: '100px'
    },
    dialog: false
  };
  data: any;
  constructor(public router: Router,
              private blockservice: BlockService,
              private user: UserService,
              private emit: EmitterService,
              private openFicheService: OpenFicheService) {

  }

  ngOnInit() {
    this.loading = true;
    this.openFicheService.getMyUnlockRequests().subscribe(res => {
      this.dataSource.data = res.map(request => {
        request.dateFiche = moment(request.dateFiche).format(DATE_D_M_Y_SLASH_FORMAT);
        request.dateDemande = moment(request.dateDemande).format(DATE_D_M_Y_SLASH_FORMAT);
        return {...request};
      });
      this.loading = false;
    },
    error => console.log('error while getting requests'),
    () => this.loading = false)
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }


}



// WEBPACK FOOTER //
// ./src/app/view/unlock-requests-suivi/unlock-requests-suivi.component.ts